// extracted by mini-css-extract-plugin
export default {"droppableWrapper":"LearningIntentions__droppableWrapper___lXof0"};